interface User {
  id: number;
  name: string;
  email: string;
  roles: string[];
  permissions: string[];
}

export const setupAuthData = (token: string, user: User) => {
  localStorage.setItem("isAuth", "true");
  localStorage.setItem("app_identifier", token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("userRole", user.roles[0]);
  localStorage.setItem("permissions", JSON.stringify(user.permissions));
};

export const removeAuthData = () => {
  localStorage.removeItem("isAuth");
  localStorage.removeItem("app_identifier");
  localStorage.removeItem("user");
  localStorage.removeItem("userRole");
  localStorage.removeItem("permissions");
};
